/**
 * General saga
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class GeneralSaga {}

export { GeneralSaga };
